export default __webpack_public_path__ + "static/media/edit.29b9b587.svg";